import { Link } from "react-router-dom";
import { PublicNav } from "@/components/PublicNav";

export function PublicHeader({ testid = "public-header" }) {
  return (
    <header className="relative z-50 flex items-center justify-between px-6 sm:px-12 py-4 bg-white border-b border-slate-200" data-testid={testid}>
      <Link to="/" className="flex shrink-0 items-center gap-3 rounded-2xl bg-white px-3 sm:px-4 py-2 border border-slate-200" data-testid={`${testid}-logo`}><img src="/brand/beaichy-logo.svg" alt="BeAIchy" className="h-8 w-auto min-w-[110px]" /></Link>
      <PublicNav testid={testid} />
    </header>
  );
}
